import {Modal} from "antd";
import React, {useEffect, useState} from "react";
import {BgColorsOutlined} from "@ant-design/icons";
import FilterButton from "../../piece/FilterButton";
import ColorTypeSelect from "../../piece/ColorTypeSelect";

export default (props) => {
    const [visible, setVisible] = useState(false)
    const [defaultValue, setDefaultValue] = useState(null)
    const [value, setValue] = useState(null)
    useEffect(() => {
        setDefaultValue(props.defaultValue)
    }, [props])

    return (
        <>
            <FilterButton
                onClick={() => {
                    setVisible(true)
                }}
            >
                <BgColorsOutlined/> Color
            </FilterButton>
            <Modal
                title='Color Filter'
                visible={visible}
                open={visible}
                onOk={() => {
                    if (props.onChange) {
                        props.onChange({
                            colorFilter: {
                                text: 'Color',
                                value: value
                            },
                        })
                    }
                    setVisible(false)
                }}
                onCancel={() => {
                    setVisible(false)
                }}
                destroyOnClose={true}
            >
                <ColorTypeSelect
                    placeholder='Please select the color'
                    defaultValue={defaultValue}
                    onChange={setValue}
                />
            </Modal>
        </>
    )
}